import {QuestionModel} from '../question.model';
import {ImageCategoryTypes} from '../shared/imageType.model';
import {RangeModel} from '../shared/range.model';
import {Enums} from '../../extensions/enums';
import {QuestionExtendedModel} from '../question-extended.model';

export class MeasurementComparisonModel extends QuestionExtendedModel {

  majorVersion = 1;
  minorVersion = 8;
  revisionVersion = 1;

  model: {
    numItems: RangeModel,
    metricType: string,
    interpretation: string,
    imageCategory: string,
    metricSystem: {
      baseUnit: string,
      list: { value: number, image: string }[]
    },
    usCustomarySystem: {
      baseUnit: string,
      list: { value: number, image: string }[]
    }
  } = {
    numItems: new RangeModel(),
    metricType: Enums.Metrics.length,
    interpretation: Enums.Comparisons.min,
    imageCategory: ImageCategoryTypes.monsters,
    metricSystem: {
      baseUnit: Enums.MetricLengths.cm,
      list: []
    },
    usCustomarySystem: {
      baseUnit: Enums.USCustomaryLengths.in,
      list: []
    }
  };

  static generateModel(json: any): MeasurementComparisonModel {

    const q = new MeasurementComparisonModel();

    const model = json.model;
    if (model) {

      q.model.numItems = RangeModel.generateModel(model.numItems);
      q.model.metricType = model.metricType;
      q.model.interpretation = model.interpretation;
      q.model.imageCategory = model.imageCategory;

      q.model.metricSystem = model.metricSystem;
      q.model.usCustomarySystem = model.usCustomarySystem;

    }

    return q;

  }

}
